import { render, staticRenderFns } from "./EditMemberConfigDialog.vue?vue&type=template&id=ea38f1fc&scoped=true&lang=pug&"
import script from "./EditMemberConfigDialog.vue?vue&type=script&lang=ts&"
export * from "./EditMemberConfigDialog.vue?vue&type=script&lang=ts&"
import style0 from "./EditMemberConfigDialog.vue?vue&type=style&index=0&id=ea38f1fc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea38f1fc",
  null
  
)

export default component.exports